import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SplashScreen({ onComplete }) {
  const navigate = useNavigate();
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    setTimeout(() => setPhase(1), 100);
    setTimeout(() => setPhase(2), 1500);
    setTimeout(() => setPhase(3), 2500);
    setTimeout(() => setPhase(4), 3800);
    setTimeout(() => {
      if (onComplete) {
        // Intro splash: call callback to show landing page
        onComplete();
      } else {
        // Post-login splash: navigate to dashboard
        navigate('/dashboard');
      }
    }, 4300);
  }, [navigate, onComplete]);

  return (
    <div className={`h-screen w-screen flex items-center justify-center overflow-hidden transition-opacity duration-500 ${phase >= 4 ? 'opacity-0' : 'opacity-100'}`}
      style={{ background: 'linear-gradient(135deg, #1a2e1a 0%, #2d4a2d 30%, #3A5A40 60%, #4a6e4a 100%)' }}
    >
      {/* Ambient glow */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(163,190,140,0.3) 0%, transparent 70%)', animation: 'breathe 4s ease-in-out infinite' }}
        />
      </div>

      <div className="relative z-10 flex flex-col items-center">
        {/* Logo */}
        <div className={`transition-all duration-1000 ease-out ${phase >= 1 ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}`}>
          <img
            src="/logo512.png"
            alt="Mind My Mojo"
            className="rounded-3xl shadow-2xl"
            style={{
              width: '120px',
              height: '120px',
              objectFit: 'contain',
              filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.4))',
            }}
          />
        </div>

        {/* Title */}
        <div className={`mt-6 transition-all duration-700 ease-out ${phase >= 2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <h1 className="text-3xl font-bold text-white tracking-tight text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
            Mind My Mojo
          </h1>
        </div>

        {/* Subtitle */}
        <div className={`mt-2 transition-all duration-700 ease-out ${phase >= 3 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`}>
          <p className="text-sm text-white/50 tracking-[0.2em] uppercase">Emotional Wellness</p>
        </div>
      </div>

      <style>{`
        @keyframes breathe {
          0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.2; }
          50% { transform: translate(-50%, -50%) scale(1.15); opacity: 0.35; }
        }
      `}</style>
    </div>
  );
}
